export const addDataLayer = (params) => {
  const {
    title = "",
    msg = "",
    sts = "",
    jobType = "",
    subJobType = "",
    formTitle = "",
    isType = "",
    clickInternalLinks = `true`,
    tradeCustomer = null,
    taxReq = null,
    termsAndConsCheck = null,
    newsletterCheck = null,
    url = null,
    uploadedDocs = null,
    isLink = false,
    isUpload = false,
  } = params;

  const { adobeDataLayer: { getState } = {} } = window;
  const page = (getState && getState("page")) || {};
  const pageType = page?.category?.pageType?.toLowerCase();
  const pageName = `${pageType}:${page?.category?.subCategoryID?.toLowerCase()}`

  const submitAnalyticsJSON =
    title === "submit"
      ? {
          jobType,
          subJobType,
          existingTradeCustomer: tradeCustomer ? "yes" : "no",
          requestTaxExemptionStatus: taxReq ? "yes" : "no",
          termsAndConditions: termsAndConsCheck ? "yes" : "no",
          newsletterSignUp: newsletterCheck ? "yes" : "no",
        }
      : null;

  const uploadedFiles =
    title === "upload business documentation" || title === "submit"
      ? uploadedDocs?.map((image) => ({
          fileName: image?.path?.split(".")?.[0]?.toLowerCase() || "n/a",
          fileType: image?.path?.split(".")?.[1] || "n/a",
          fileSize: `${(image?.size / 1e6).toFixed(3)} mb` || "n/a",
        }))
      : null;

  const uploadedFilesJSON = uploadedFiles ? { uploadedFiles } : null;

  let internalLinkType, eventAction, internalLinkZoneName, internalLinkName;

  if (isLink) internalLinkType = `${pageType}:navigation`;
  else if (isUpload) {
    eventAction = `${pageName}:${formTitle}:${title}:${isType}`;
    internalLinkZoneName = `${pageName}:${formTitle}:${title}`;
    internalLinkName = `${isType}`;
    internalLinkType = `${pageType}:navigation`;
  }

  const eventInfo = {
    eventAction: eventAction || `${pageName}:${formTitle}:${title}`,
    eventName: eventAction || `${pageName}:${formTitle}:${title}`,
    eventType: `navigation`,
    eventMsg: msg || "n/a",
    eventStatus: sts || "n/a",
    internalLinkName: internalLinkName || `${title}`,
    internalLinkPosition: `${pageName}`,
    internalLinkType: internalLinkType || `${pageType}:${title}`,
    internalLinkZoneName: internalLinkZoneName || `${pageName}:${formTitle}`,
    internalLinkURL: url || "n/a",
    clickInternalLinks: clickInternalLinks,
    ...submitAnalyticsJSON,
    ...uploadedFilesJSON,
  };

  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  });
};
